<div class="table-container">

    <apc-report-datatable-filters (exportCSVEvent)="exportCSV()" (refreshDataEvent)="refreshData()"
        (selectTableColumnsEvent)="addNewColumn($event);" (selectAllColumnsEvent)="selectAllColumns()"
        (unselectAllColumnsEvent)="unselectAllColumns()" [columnsToDisplayInDropdown]="columnsToDisplayInDropdown"
        [showSearch]="showSearch" [enableFilter]="enableFilter" [selectedTableColumns]="selectedTableColumns"
        (copyToClipboardEvent)="copyToClipboard()" (exportSheetEvent)="exportSheet()" (setToken)="setToken($event)"[iconsExpanded]="iconsExpanded">
    </apc-report-datatable-filters>

    <ngx-datatable #tableReports class="apc" [rows]="rows" [columnMode]="'force'" [footerHeight]="50"
        rowHeight="auto" [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size"
        (page)="setPage($event)" [sortType]="SortType.single" (sort)="onSort($event)" [externalSorting]="true"
        [columns]="selectedTableColumns" [externalPaging]="true" [sorts]="sortArray"
        [ngClass]="hasNavigation ? 'hasNavigation' : 'noNavigation'">

        <ng-template #dateCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | date: 'dd/MM/yyyy HH:mm'}} </div>
        </ng-template>

        <ng-template #percentageCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | percent: '1.0-2':'it' }} </div>
        </ng-template>

        <ng-template #timeCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{ (value !== '') ?
                (convertStringToDate(value) | date:'HH:mm') : "" }} </div>
        </ng-template>

        <ng-template #plainCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value}} </div>
        </ng-template>

        <ng-template #numberCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | number:'1.0-2': 'it'}} </div>
        </ng-template>

        <ng-template #currencyCell let-row="row" let-value="value" let-column="column">
            <div isEllipsisActive [id]="column.name" class="column-value"
                [ngClass]="showSearch && !columnsNotToFilter.includes(column.name) ? 'text-decoration-underline' : ''">
                {{value | number:'1.2-2': 'it'}} € </div>
        </ng-template>

        <ng-template #translateCell let-column="column">
            <div isEllipsisActive class="header-cell">
                {{column.name}}
                <div *ngIf="column.description" class="help-column-icon">
                    <apc-help-icon [text]="column.description">
                    </apc-help-icon>
                </div>
            </div>
        </ng-template>

        <ng-template #greenEyeIconHomepage let-row="row" let-value="value">
            <a class="greenEye" [routerLink]="row.system.target"
                ngbTooltip="{{row.system.target_label ? 'Go to ' + row.system.target_label : 'Go to Resource'}}"
                tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
            </a>
        </ng-template>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                <div class="page-count">
                    {{rowCount}} total
                </div>

                <div class="footer_controls">
                    <div class="dropdown_pageElements" *ngIf="rowCount && rowCount > 0">
                        <select class="form-control custom_select" [(ngModel)]="pageElements" (change)="setPageSize($event)">
                            <option *ngFor="let pageElements of pageDropDown" [value]="pageElements">{{pageElements === 20000 ? 'All' : pageElements}}</option>
                        </select>
                    </div>
                    
                    <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
                        [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage"
                        [size]="pageSize" [count]="rowCount" [hidden]="!((rowCount / pageSize) > 1)"
                        (change)="setPage({count: page.totalElements, limit: pageElements, offset: $event.page - 1, pageSize: pageElements })">
                    </datatable-pager>
                </div>

            </ng-template>
        </ngx-datatable-footer>

    </ngx-datatable>

</div>